import { connect } from 'react-redux'
import { selectIsInboxBootstrapped } from 'ducks/bootstrap/selectors/selectIsInboxBootstrapped'
import { selectCurrentSearchIsError } from 'ducks/searches/selectors'

import { selectAgentHasMailboxAccess } from 'ducks/mailboxes/selectors/selectAgentHasMailboxAccess'
import { doHideLaunchBar } from 'actions/app'
import { selectShowInboxesEmptyPage } from 'selectors/trial_setup'
import { selectIsBootstrapped } from 'ducks/bootstrap/selectors/selectIsBootstrapped'
import { selectShouldHideFeaturesAnnoucement } from 'ducks/flags/selectors'
import Layout from './view'

const select = state => {
  return {
    hasMailboxAccess: selectAgentHasMailboxAccess(state),
    hasSearchErrored: selectCurrentSearchIsError(state),
    showEmptyInboxPage: selectShowInboxesEmptyPage(state),
    isInboxBootstrapped: selectIsInboxBootstrapped(state),
    isBootstrapped: selectIsBootstrapped(state),
    shouldHideAnnouncement: selectShouldHideFeaturesAnnoucement(state),
  }
}

const perform = {
  doHideLaunchBar,
}

export default connect(select, perform)(Layout)
